<template>
    <v-container fluid>
        <v-col cols="12">
            <v-tabs left>
                <v-tab @click.native.prevent="changeTab('contracts')" key="contracts" href="#contracts">
                    {{ $t('tabs.allContracts') }}
                </v-tab>
                <v-tab
                    @click.native.prevent="changeTab('templates')"
                    key="templates"
                    href="#templates"
                    v-if="$myStore.state.user.user_role_id == 1"
                >
                    {{ $t('tabs.templates') }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item key="contracts" value="contracts">
                    <ContractsAll></ContractsAll>
                </v-tab-item>
                <v-tab-item key="templates" value="templates" v-if="$myStore.state.user.user_role_id == 1">
                    <ContractTemplates></ContractTemplates>
                </v-tab-item>
            </v-tabs-items>
        </v-col>
    </v-container>
</template>

<script>
import ContractTemplates from './ContractTemplates.vue';
import ContractsAll from './ContractsAll.vue';

export default {
    name: 'Entities',
    components: {ContractTemplates, ContractsAll},
    data: function () {
        return {
            tabMain: 'contracts',
            tab: 'contracts',
            currentTab: 'contracts',
        };
    },
    methods: {
        changeTab(id) {
            this.tab = this.currentTab;
            this.tabMain = this.currentTab;
            this.tab = id;
            this.currentTab = id;
            this.tabMain = id;
        },
    },
    mounted() {
        if (this.$myStore.state.user.user_role_id != 1) {
            this.tabMain = 'contracts';
            this.tab = 'contracts';
            this.currentTab = 'contracts';
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.contracts'), href: '/#/contracts', disabled: true},
        ]);
    },
};
</script>

<style scoped></style>
